/**
 * External dependencies
 */
import React from 'react';
import { omit } from 'lodash';

import { TowerProvider } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import Popover from './index';

/**
 * Style dependencies
 */
import './styles.scss';

const PopoverMenu = (props) => {
	const content = (
		<TowerProvider>
			<div role='menu' className='popover__menu'>
				{props.content}
			</div>
		</TowerProvider>
	);

	return (
		<Popover
			position={props.position}
			isOpen={props.isOpen}
			content={content}
			tipSize={-1}
			{...omit(props, ['isOpen', 'position', 'content'])}
		>	
			<div>
				{props.children}
			</div>
		</Popover>
	);
};

PopoverMenu.defaultProps = {
	position: 'bottom',
};

export default PopoverMenu;
